import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  amount: {
    id: 'widgets.bank_history.amount',
    defaultMessage: 'Amount',
    description: 'Title of Amount axis in chart',
  },
  notFoundError: {
    id: 'widgets.bank_history.not_found',
    defaultMessage: 'This application does not have any synced accounts',
    description: 'Error when no BanksUser are found',
  },
  noAccountsError: {
    id: 'widgets.bank_history.no_accounts',
    defaultMessage: 'No bank account collected',
    description: 'Error when BanksUser does not have any checkings accounts',
  },
  noTransactionsError: {
    id: 'widgets.bank_history.no_transactions',
    defaultMessage: 'No bank transaction collected',
    description: 'Error when BanksUser does not have any transactions',
  },
  genericError: {
    id: 'widgets.bank_history.generic_error',
    defaultMessage: 'An error occurred',
    description: 'Generic error message in bank history widget',
  },
});
